import { render, staticRenderFns } from "./adminRepairList.vue?vue&type=template&id=5151e05e&scoped=true"
import script from "./adminRepairList.vue?vue&type=script&lang=js"
export * from "./adminRepairList.vue?vue&type=script&lang=js"
import style0 from "./adminRepairList.vue?vue&type=style&index=0&id=5151e05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5151e05e",
  null
  
)

export default component.exports